import Image from "next/image";
import { Trans } from "next-i18next";

import { useCheckIsMobile } from "@sellernote/shared/src/utils/hook";
import useOnceActivatedIntersectionObserver from "@sellernote/features/src/common/hooks/useOnceActivatedIntersectionObserver";

import Styled from "./index.styles";

export function AlibabaCouponSection() {
  const { isMobile } = useCheckIsMobile();

  const { target, isActivatedTarget } = useOnceActivatedIntersectionObserver({
    threshold: 0.3,
  });

  return (
    <Styled.container ref={target}>
      <Styled.content>
        <Styled.titleAndDesc>
          <Styled.title
            className={`fade-up-animation ${isActivatedTarget ? "active" : ""}`}
          >
            <Trans
              i18nKey="page-sourcing:알리바바닷컴에서_100만원_어치_구매했다면__br_/_수출입_운송쿠폰_3만원_이_자동_발급돼요_"
              components={{ br: <br /> }}
            />
          </Styled.title>
          <Styled.desc
            className={`fade-up-animation ${isActivatedTarget ? "active" : ""}`}
          >
            <Trans
              i18nKey="page-sourcing:주문_시점으로부터_최대_3영업일_이내_지급돼요._br_/_최대__150/1회_지급됩니다."
              components={{ br: <br /> }}
            />
          </Styled.desc>
        </Styled.titleAndDesc>

        <Image
          className={`coupon-image fade-up-animation ${
            isActivatedTarget ? "active" : ""
          }`}
          src={"/assets/images/sourcing/alibaba-coupon.png"}
          alt={`alibaba-coupon`}
          width={isMobile ? 210 : 353}
          height={isMobile ? 107 : 180}
          unoptimized
          placeholder="blur"
          blurDataURL="/assets/images/landing/section-image-blur-data.png"
        />
      </Styled.content>
    </Styled.container>
  );
}
